import { Box, Typography } from '@mui/material';
import { InfinitySpinner } from '@socialgoodsoftware/theme';

export type MainLoaderProps = {
  loaderText?: string;
  minHeight?: string;
};

export function LoaderText({ loaderText }: MainLoaderProps) {
  return (
    <Box
      role="status"
      aria-busy="true"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
      }}
    >
      <InfinitySpinner size="page" />
      <Typography variant="body1" sx={{ color: 'text.secondary' }}>
        {loaderText}
      </Typography>
    </Box>
  );
}

export function MainLoader({ loaderText = 'Loading...', minHeight = '100vh' }: MainLoaderProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        minHeight: minHeight,
        width: '100%',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <LoaderText loaderText={loaderText} />
    </Box>
  );
}
